import React, { useRef, useState } from 'react';
import './_commonjsHelpers-df867233.js';
import { P as PropTypes } from './index-6a8f8095.js';
import styled, { css } from 'styled-components';
import { _ as _taggedTemplateLiteral, a as _objectWithoutProperties, c as _slicedToArray } from './_rollupPluginBabelHelpers-b3c9b1cd.js';
import './_baseEach-3b97c1a8.js';
import './isArray-a3f14da2.js';
import './_Map-9acd9da3.js';
import './get-f58f8821.js';
import './_baseIteratee-651c88ed.js';
import './index-7f6959fc.js';
import './index-ae4b14fb.js';
import { _ as _head } from './head-b3f271d9.js';
import './map-651e82c0.js';
import './join-15b17329.js';
import './noop-d79f8d84.js';
import './isEmpty-9e4c9724.js';
import './wrapMediaQuery-d94fbf55.js';
import { Text } from './Typographies.js';
import './index-f96168ba.js';

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  flex-direction: column;\n  align-items: flex-start;\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var sizes = css(["height:", ";width:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.components.inputFile.sizes.height;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.components.inputFile.sizes.width;
});
var StyledContainer = styled.div(_templateObject(), sizes);

function _templateObject$1() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  text-align: ", ";\n\n  cursor: pointer;\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var border = css(["border:", ";border-radius:", ";"], function (_ref) {
  var variant = _ref.variant,
      theme = _ref.theme;
  return "".concat(theme.components.inputFile.borders[variant].borderWidth, " solid ").concat(theme.components.inputFile.colors[variant].border);
}, function (_ref2) {
  var variant = _ref2.variant,
      theme = _ref2.theme;
  return theme.components.inputFile.borders[variant].borderRadius;
});
var colors = css(["background-color:", ";color:", ";&:hover{opacity:", ";}"], function (_ref3) {
  var variant = _ref3.variant,
      theme = _ref3.theme;
  return theme.components.inputFile.colors[variant].background;
}, function (_ref4) {
  var variant = _ref4.variant,
      theme = _ref4.theme;
  return theme.components.inputFile.colors[variant].text;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.components.inputFile.opacities.hover;
});
var sizes$1 = css(["height:", ";width:", ";"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.components.inputFile.sizes.height;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.components.inputFile.sizes.width;
});
var spaces = css(["padding:", " ", ";"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.components.inputFile.spaces.paddingHeight;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.components.inputFile.spaces.paddingWidth;
});
var StyledFilePicker = styled(Text.withComponent('button'))(_templateObject$1(), border, colors, sizes$1, spaces, function (_ref10) {
  var theme = _ref10.theme;
  return theme.components.inputFile.textAlign;
});
StyledFilePicker.defaultProps = {
  variant: 'normal'
};

function _templateObject$2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  overflow: hidden;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  width: 1px;\n  margin: -1px;\n  padding: 0;\n  border: 0;\n"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var StyledInput = styled.input(_templateObject$2());

function _templateObject$3() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}

var InputFile = function InputFile(_ref) {
  var name = _ref.name,
      onChange = _ref.onChange,
      placeholder = _ref.placeholder,
      variant = _ref.variant,
      rest = _objectWithoutProperties(_ref, ["name", "onChange", "placeholder", "variant"]);

  var input = useRef(null);

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      file = _useState2[0],
      setFile = _useState2[1];

  var onChangeFile = function onChangeFile() {
    var file = _head(input.current.files) || {};
    setFile(file);
    onChange && onChange(file);
  };

  var onDrop = function onDrop(e) {
    e.preventDefault();
    var item = _head(e.dataTransfer.items) || {};
    item.kind === 'file' && setFile(item.getAsFile() || {});
  };

  var browseFile = function browseFile() {
    return input && input.current.click();
  };

  var allowDrop = function allowDrop(e) {
    return e.preventDefault();
  };

  return React.createElement(StyledContainer, rest, React.createElement(StyledInput, {
    name: name,
    type: "file",
    ref: input,
    onChange: onChangeFile
  }), React.createElement(StyledFilePicker, {
    onClick: browseFile,
    onDragOver: allowDrop,
    onDrop: onDrop,
    variant: variant
  }, file ? file.name : placeholder));
};

InputFile.defaultProps = {
  name: '',
  placeholder: '',
  variant: 'normal'
};
InputFile.propTypes = {
  /**
   * The name of the input file.
   */
  name: PropTypes.string,

  /**
   * The placeholder of the input file.
   */
  placeholder: PropTypes.string,

  /**
   * The function to be called when a file is selected.
   * @param: the html file object.
   */
  onChange: PropTypes.func.isRequired,

  /**
   * The type of variation to display
   */
  variant: PropTypes.oneOf(['primary', 'secondary', 'normal'])
};
/** @component */

var index = styled(InputFile)(_templateObject$3());

export default index;
